import Profile from '../components/Profile'
import React from 'react'

const LoginPage = () => {
    return (
        <div>
            <Profile />
        </div>

 )
}

export default LoginPage
